import React from "react";
import s from "../styles/footer.module.css";

export default function Footer() {
  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <div className={s.socialRow}>
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            className={s.socialIcon}
          >
            in
          </a>
          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            className={s.socialIcon}
          >
            ig
          </a>
          <a
            href="https://www.facebook.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className={s.socialIcon}
          >
            f
          </a>
          <a
            href="https://medium.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Medium"
            className={s.socialIcon}
          >
            m
          </a>
          <a
            href="https://x.com"
            target="_blank"
            rel="noreferrer"
            aria-label="X"
            className={s.socialIcon}
          >
            x
          </a>
        </div>

        <nav className={s.linksRow}>
          <a href="/terms">Terms of Use</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/apps/support">Press Page</a>
          <a href="/apps/support">Company Details</a>
        </nav>

        <div className={s.divider} />

        <div className={s.copyBlock}>
          <p className={s.copy}>Copyright (c) 2025 Goodwave Lab. All rights reserved.</p>

          <p className={s.legal}>
            Apple, the Apple logo, iPhone, iPad, and iPod touch are trademarks of
            Apple Inc., registered in the U.S. and other countries. App Store is
            a service mark of Apple Inc.
          </p>

          <p className={s.legal}>
            Google, the Google logo, Google Play and the Google Play logo are
            trademarks of Google LLC, registered in the U.S. and other countries.
          </p>
        </div>
      </div>
    </footer>
  );
}
